<template>
  <div id="app">
    <router-view />

    <van-tabbar v-model="activeTab" v-if="showTabbar" style="z-index:999;">
      <van-tabbar-item icon="wap-home-o" @click="switchTab('home')">首页</van-tabbar-item>
      <van-tabbar-item icon="orders-o" @click="switchTab('orders')">订单</van-tabbar-item>
      <van-tabbar-item icon="manager-o" @click="switchTab('mine')">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>

<script>
import stroe from './store'

const TAB_HOME = 0
const TAB_ORDERS = 1
const TAB_MINE = 2

const TAB_ROUTES = {
  home: '/payment',
  orders: '/my-orders',
  mine: '/mine'
}

export default {
  data() {
    return {
      activeTab: TAB_HOME,
      showTabbar: !this.$route.meta.hideTabbar
    }
  },
  watch: {
    '$route.path'(newPath) {
      this.$common.visitStatic(location.href)
      if (newPath === TAB_ROUTES.mine) {
        this.activeTab = TAB_MINE
      } else if (newPath === TAB_ROUTES.orders) {
        this.activeTab = TAB_ORDERS
      } else {
        this.activeTab = TAB_HOME
      }
    },
    '$route.meta.hideTabbar'(hide) {
      this.showTabbar = !hide
    },
    getStoreItem(newval) {
      this.activeTab = stroe.state.tarbarIndex
    }
  },
  created() {
    this.checkInviter()
  },
  methods: {
    checkInviter() {
      const urlParams = new URLSearchParams(window.location.search)
      let inviterId = urlParams.get('inviter_id')
      
      // 兼容处理：如果参数在 hash 路由后面 (例如 #/payment?inviter_id=1)
      if (!inviterId && this.$route && this.$route.query.inviter_id) {
        inviterId = this.$route.query.inviter_id
      }

      if (inviterId) {
        localStorage.setItem('saas_inviter_id', inviterId)
        // 如果已经登录，尝试绑定
        if (this.$common.getAuth()) {
          this.bindInviter(inviterId)
        }
      }
    },
    async bindInviter(inviterId) {
      try {
        await this.$common.cusHttp(
          this,
          '/api/saas_finance.php?action=bind_inviter',
          { inviter_id: inviterId },
          'post'
        )
      } catch (e) {
        console.error('绑定邀请人失败', e)
      }
    },
    switchTab(tab) {
      const path = TAB_ROUTES[tab]
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
    }
  },
  computed: {
    getStoreItem() {
      return stroe.state.tarbarIndex
    }
  }
}
</script>
